// @ts-nocheck
import React, { createContext, useContext } from 'react';
import { useShippingAccounts } from '@/hooks/query';

const ShippingAccountsContext = createContext();

function ShippingAccountsProvider({ ...props }) {
  const { data: shippingAccounts, isLoading: isShippingAccountsLoading } =
    useShippingAccounts();

  const state = { shippingAccounts, isShippingAccountsLoading };

  return <ShippingAccountsContext.Provider value={state} {...props} />;
}

const useShippingAccountsContext = () => useContext(ShippingAccountsContext);

export { ShippingAccountsProvider, useShippingAccountsContext };